var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46.5,
  height: 46.5,
  x: 0.75,
  y: 0.75,
  stroke: "#183690",
  strokeWidth: 1.5,
  rx: 23.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#183690",
  d: "m37.696 24.721-4-10a.75.75 0 0 0-.857-.453l-8.089 1.797V13a.75.75 0 1 0-1.5 0v3.399l-8.412 1.875a.75.75 0 0 0-.534.453l-4 10a.8.8 0 0 0-.054.273c0 2.733 2.914 3.75 4.75 3.75s4.75-1.017 4.75-3.75a.8.8 0 0 0-.054-.279l-3.672-9.18 7.226-1.606V34.25H21a.75.75 0 1 0 0 1.5h6a.75.75 0 1 0 0-1.5h-2.25V17.601l7.026-1.561-3.472 8.681a.8.8 0 0 0-.054.279c0 2.733 2.914 3.75 4.75 3.75s4.75-1.017 4.75-3.75a.8.8 0 0 0-.054-.279M15 31.25a4.6 4.6 0 0 1-2.185-.57c-.671-.391-1.019-.898-1.061-1.546l3.25-8.114 3.25 8.114c-.122 1.722-2.432 2.116-3.254 2.116m18-4a4.6 4.6 0 0 1-2.185-.57c-.671-.391-1.019-.898-1.061-1.546l3.25-8.114 3.25 8.114c-.121 1.722-2.431 2.116-3.254 2.116"
})));
export default SvgWeight;